const TimeEntryTypes = {
    "Client Visit": 1,
    "Out of Office": 2,
    "Others": 3
};

export default TimeEntryTypes;